export const extractUrlFromMultiPicker = (urlObject: UmbracoTypes.TMultiPickerUrl): string =>
  urlObject && urlObject[0] && urlObject[0].url
    ? `${urlObject[0].url}${urlObject[0].queryString || ''}`
    : '';

export default extractUrlFromMultiPicker;
